"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Secure = void 0;
var react_1 = __importDefault(require("react"));
var Secure = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    react_1.default.createElement("path", { d: "m11 0 8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L11 22l-6.328-4.219A5.998 5.998 0 0 1 2 12.79V2.802a1 1 0 0 1 .783-.976L11 0Zm0 2.049L4 3.604v9.185a4 4 0 0 0 1.781 3.328L11 19.597l5.219-3.48A3.998 3.998 0 0 0 18 12.79V3.604L11 2.05v-.001Zm4.452 5.173 1.415 1.414L10.503 15 6.26 10.757l1.414-1.414 2.828 2.828 4.95-4.95v.001Z", fill: "currentColor" }))); };
exports.Secure = Secure;
